/**
 * Lightweight retry util for functions returning promises
 * @param  {Function} f                         Function to retry
 * @param  {[type]}   delay                     Delay between retry attempts
 * @param  {[type]}   numberOfRemainingAttempts Number of attempts
 * @return {Promise}
 */

function retry(f, delay, numberOfRemainingAttempts) {
  return new Promise((resolve, reject) => {
    return f()
      .then(resolve)
      .catch((err) => {
        if (numberOfRemainingAttempts === 1) {
          reject(err);
        } else {
          setTimeout(
            () => resolve(retry(f, delay, numberOfRemainingAttempts - 1)),
            delay
          );
        }
      });
  }).catch((err) => Promise.reject(err));
}

module.exports = retry;
